import Vue from "vue";
import { INotificationOnClickResult, Notification } from "./notification";

export class NewCrmAssignedNotification extends Notification {
	public async onClick(vue: Vue): Promise<INotificationOnClickResult> {
		return {
			routeTo: `/crm/edit/${this.Data.id}`
		};
	}

	public getIcon():string {
		return "handshake";
	}

	public getActionKey():string {
		return "open-crm";
	}
}
